module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/TriangleDownSolidSmall.97f5618d.svg";